export default {
  id: "workingHours",
  i18nTitle: "tours.workingHours.title",
  steps: [
    {
      id: "workingHours.welcome",
      target: null,
      path: "/appointments",
      i18nBody: "tours.workingHours.step1.body",
    },
    {
      id: "workingHours.dayRow",
      target: "hours-day-row",
      path: "/working-hours/:me",
      i18nBody: "tours.workingHours.step2.body",
    },
    {
      id: "workingHours.picker",
      target: "hours-time-picker",
      path: "/working-hours/:me",
      i18nBody: "tours.workingHours.step3.body",
    },
    {
      id: "workingHours.save",
      target: "hours-save-button",
      path: "/working-hours/:me",
      i18nBody: "tours.workingHours.step4.body",
    },
  ],
};
